import styled from 'styled-components'

import { FlyerCodesGiveOutWidgetUnstyled } from 'Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/unstyled'

export const FlyerCodesGiveOutWidget = styled(FlyerCodesGiveOutWidgetUnstyled)`
  position: relative;
  border: 1px solid #eceef0;
  border-radius: 4px;
  background-color: #fafafa;

  .CodeBlock:first-child {
    margin-left: 0;
  }

  .CodeBlock:last-child {
    margin-right: 0;
  }

  .CodeBlock {
    position: absolute;
    cursor: pointer;
  }

  .CodeSelectDropDown {
    width: 256px;
    display: inline-block;
    vertical-align: top;
    margin-right: 2px;
    margin-top: 2px;
  }

  .CodeBlocksContainer {
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: 100%;
    padding-bottom: 20px;
  }

  .CodeBlocksContainer.DropZone:hover {
    background-color: blue;
  }

  .AvailableCodesContainer {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    /*user-select: none;*/
  }

  .AvailableCodesContainer .header {
    padding-left: 30px;
    /*user-select: none;*/
  }

  .GiveOutContainer {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }

  h3 {
    color: #7e8fa5;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 1.5px;
  }

  h3.flaggedBa {
    color: #ef405d;
    text-decoration: line-through;
  }

  .header {
    background-color: white;
    padding: 30px 10px 25px 10px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #7e8fa5;
    font-size: 11px;
    font-weight: bold;
    /*user-select: none;*/
  }

  .content {
    padding: 10px;
    max-height: 350px;
    overflow-x: auto;
    /*user-select: none;*/
  }

  .BADropZoneNotActive {
    padding: 10px;
    box-sizing: border-box;
    border: 2px dashed transparent;
  }

  .BADropZone {
    padding: 10px;
    box-sizing: border-box;
    border: 2px dashed transparent;
  }

  .BADropZone:hover {
    background-color: #f7f4f4;
    border: 2px dashed #afa9a9;
  }

  .BADropZone:hover > .CodeBlocksContainer {
    opacity: 0.5;
  }

  .view-summary {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 20px;
    color: #9f9f9f;
    font-size: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/Containers/Form/City/Pickup/FlyerCodesGiveOutWidget/index.js